import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const ObjectRepository = RepositoryFactory.get('UserPermissionRepository')['ObjectRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create, update, remove } = DefaultStoreActions(ObjectRepository)

export const STORE_MODULE_NAME = 'user_permission_object';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
        update: update,
        delete: remove,
    },
}
